import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { MeterType, MeterTypeRequestBody } from './types';

export const meterTypesApi = createApi({
  reducerPath: 'meterTypesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/meter-types`,
  }),
  tagTypes: ['MeterType', 'MeterTypes'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getMeterTypes: builder.query<MeterType[], void>({
      query: () => ({
        url: '/',
      }),
      providesTags: () => ['MeterType', 'MeterTypes'],
    }),
    getMeterTypeById: builder.query<MeterType, string>({
      query: id => ({
        url: `/${id}`,
      }),
      providesTags: () => ['MeterType'],
    }),
    createMeterType: builder.mutation<MeterType, MeterTypeRequestBody>({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: result => [
        'MeterType',
        { type: 'MeterType', id: result?.id },
      ],
    }),
    updateMeterType: builder.mutation<MeterType, MeterTypeRequestBody>({
      query: data => ({
        url: `/${data.id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: result => [
        'MeterType',
        { type: 'MeterType', id: result?.id },
      ],
    }),
    deleteMeterTypeById: builder.mutation<void, string>({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => ['MeterType', { type: 'MeterType', id }],
    }),
  }),
});

export const { useGetMeterTypesQuery } = meterTypesApi;
